document.addEventListener('teeinblue-event-component-injected', function() {
  let atc_has_attr = document.querySelector('#AddToCart[data-cart-add]');
  let atc = document.querySelector('#AddToCart');
  let form = Array.from(document.forms).find(form => form.contains(atc));
  form.setAttribute('data-cart-submit', atc_has_attr.getAttribute('data-cart-add'));
  atc.removeAttribute('data-cart-add');
  
  document.addEventListener('product:added', () => CartJS.getCart());
  
  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: false, subtree: false };
  
  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes") {
        if (atc.getAttribute('data-action') === 'add-to-cart') {
          atc.removeAttribute('data-action');
        }
      }
    }
  };
  
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);
  
  // Start observing the target node for configured mutations
  observer.observe(atc, config);
})